<script lang="ts">
    import MainLayout from "../../#common/layout/Layout.svelte"
    import {doShow as showAlert} from 'src/components/#common/alert/store'
    import Modal from 'src/components/#common/modal/Modal.svelte'
    import {Link} from 'svelte-routing'
    import {getImages, deleteNftImage} from 'src/components/cabinet/#services/nftImages'
    import Pagination from 'src/components/#common/pagination/Pagination.svelte'
    import IconifyIcon from '@iconify/svelte'
    import deleteIcon from '@iconify/icons-fa-solid/trash-alt'

    let deleteModalOpen = false
    let deleteSending = false
    let selectedId
    let currentPage = 0
    let perPage = 30
    let maxButtons = 5
    let collection = 'meowgon'

    $:currentPage,perPage,collection,update()

    function update() {
        getImages.send({ data: { page: currentPage + 1, perPage, collection } })
        $getImages.value
    }

    async function deleteHandler() {
        try {
            deleteSending = true

            await deleteNftImage.request({ data: { id: selectedId } })

            showAlert.set({
                status: 'success',
                text: 'Item successfully deleted'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            deleteSending = false
            deleteModalOpen = false
            update()
        }
    }
</script>

<svelte:head>
    <title>NFT images</title>
</svelte:head>

<MainLayout title="NFT images">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                <Link to="nft" class="btn btn-primary mb-3">Back</Link>
                <div class="row">
                    <div class="col-lg-3">
                        <div class="form-group mb-3">
                            <label>Select collection</label>
                            <select class="form-select" bind:value={collection}>
                                <option value="meowgon">Meowgon</option>
                                <option value="kitsune" disabled>Kitsune</option>
                            </select>
                        </div>
                    </div>
                </div>
                {#if !$getImages.hasValue && $getImages.loading}
                    Loading...
                {:else if !$getImages.hasValue && $getImages.error }
                    Something went wrong. Try refreshing the page.
                {:else if $getImages.hasValue && $getImages.value?.totalCount}
                    <div class="row">
                        {#each $getImages.value?.data as { id, image }}
                            <div class="col-md-2 nft-col">
                                <div class="nft-card">
                                    <a href="{process.env.NFT_IMAGES_PATH}{image}" target="_blank" rel="noreferrer">
                                        {#if image}
                                            <img src="{process.env.NFT_IMAGES_PATH}{image}" class="img-fluid" alt="">
                                        {/if}
                                    </a>
                                    <button class="delete-btn" on:click={() => { selectedId = id; deleteModalOpen = true }}>
                                        <IconifyIcon icon={deleteIcon}/>
                                    </button>
                                </div>
                            </div>
                        {/each}
                    </div>
                    <Pagination
                        bind:currentPage={currentPage}
                        totalCount={$getImages.value.totalCount}
                        {perPage}
                        {maxButtons}
                        disabled={$getImages.loading}
                    />
                    <Modal bind:visible={deleteModalOpen} size="sm">
                        <svelte:fragment slot="content">
                            <div class="modal-custom__title">Delete item</div>
                            <div class="modal-custom__text">Do you really want to delete this image?</div>
                            <div class="modal-custom__footer">
                                <button class="btn btn-cancel" on:click={() => { deleteModalOpen = false }}>Cancel</button>
                                <button class="btn btn-primary" class:loading={deleteSending} on:click={deleteHandler} disabled={deleteSending}>Yes</button>
                            </div>
                        </svelte:fragment>
                    </Modal>
                {:else if $getImages.value?.totalCount === 0}
                    No items
                {/if}
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .nft-col {
        margin-bottom: 15px;
    }

    .nft-card {
        border: 1px solid #ced4da;
        height: 100%;
        border-radius: 5px;
        overflow: hidden;
        padding: 10px;
        background: #f4f5f9;
        position: relative;
        transition: .2s;
    }

    .nft-card a {
        display: flex;
        width: 100%;
        height: 100%;
        align-items: center;
        justify-content: center;
    }

    .nft-card:hover {
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    }

    .delete-btn {
        border: 0;
        background: transparent;
        color: #f44336;
        position: absolute;
        right: 0;
        top: 0;
        width: 40px;
        height: 40px;
        opacity: 0;
        transition: .25s;
    }

    .nft-card:hover .delete-btn {
        opacity: 1;
    }
</style>
